import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Management routes
const Users = Loader(
  lazy(() => import('src/content/vendor-content/management/Users'))
);
const Roles = Loader(
  lazy(() => import('src/content/vendor-content/management/Roles'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/vendor-content/management/Users/profile'))
);

const managementRoutes = [
  {
    path: '',
    element: <Navigate to="users" replace />
  },
  {
    path: 'user-management',
    children: [
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'users/:userId',
        element: <UserProfile />
      },
      {
        path: 'roles',
        element: <Roles />
      }
    ]
  }
];

export default managementRoutes;
